var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnPinIconSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-size",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8888_8394)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M5.22672 9.38086L1.13672 13.5009",
    stroke: "#312F2E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M5.25305 4.60596L5.8143 4.48096L6.9368 4.23096L9.0968 1.00096C9.17405 0.873589 9.27877 0.765088 9.40333 0.683382C9.52788 0.601675 9.66912 0.548828 9.81672 0.528701C9.96431 0.508574 10.1145 0.521676 10.2564 0.56705C10.3983 0.612424 10.5283 0.688923 10.6368 0.790957L13.8468 4.00096C13.9488 4.10949 14.0253 4.23944 14.0707 4.38133C14.1161 4.52321 14.1292 4.67344 14.1091 4.82104C14.0889 4.96863 14.0361 5.10987 13.9544 5.23443C13.8727 5.35898 13.7642 5.46371 13.6368 5.54096L10.3668 7.65096L10.1018 8.76096L9.9693 9.31596M3.28867 5.04346L3.00805 5.10596L2.4468 5.23096C2.34412 5.25587 2.24984 5.30746 2.1735 5.3805C2.09715 5.45354 2.04145 5.54545 2.01202 5.64692C1.9826 5.7484 1.98049 5.85585 2.00591 5.9584C2.03133 6.06095 2.08338 6.15498 2.1568 6.23096L8.3068 12.391C8.38464 12.4614 8.47936 12.5106 8.58177 12.5337C8.68418 12.5568 8.79083 12.5531 8.89139 12.5229C8.99196 12.4928 9.08303 12.4372 9.15581 12.3615C9.22858 12.2858 9.28059 12.1926 9.3068 12.091L9.4393 11.536L9.50555 11.2585",
    stroke: "#312F2E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M1.13672 0.5L14.1367 13.5",
    stroke: "#312F2E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    className: "icon-svg",
    id: "clip0_8888_8394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.636719)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnPinIconSmall);
export default __webpack_public_path__ + "static/media/UnPinIconSmall.f4f7290521d94a9ef476cdf2614d040f.svg";
export { ForwardRef as ReactComponent };